import { RootState } from 'store';

export const vendorsSelector = (state: RootState) => state.vendors.vendors;

export const vendorSelector = (state: RootState) => state.vendors.vendor;

export const vendorsLoadingSelector = (state: RootState) => state.vendors.loading;

export const vendorsErrorSelector = (state: RootState) => state.vendors.vendorsError;
